import { render, staticRenderFns } from "./SortOption_GffPresenceStatus.vue?vue&type=template&id=1129dc15&scoped=true&"
import script from "./SortOption_GffPresenceStatus.vue?vue&type=script&lang=js&"
export * from "./SortOption_GffPresenceStatus.vue?vue&type=script&lang=js&"
import style0 from "./SortOption_GffPresenceStatus.vue?vue&type=style&index=0&id=1129dc15&scoped=true&lang=css&"
import style1 from "./SortOption_GffPresenceStatus.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1129dc15",
  null
  
)

export default component.exports